import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div data-testid="auth-checking" className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-faytex-pink animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
